import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '@src/api';
import type { CmApi, ReportTypeDto } from '@src/api';

import { preloaderStore } from '../../preloaderStore';

export type ReportTypeDtoDefId = Omit<ReportTypeDto, 'id' | 'code'> & { id: string; code: string };

class ReportTypesStore {
  reportTypes: ReportTypeDtoDefId[] = [];

  isChanged = false; // флаг, что справочник изменился для проверки загрузки в fetchReferences

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  setIsChanged = (value: boolean) => {
    this.isChanged = value;
  };

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.reportTypes.getReportTypes();

    runInAction(() => {
      this.reportTypes = (data as ReportTypeDtoDefId[])?.map((item) => ({ ...item, id: item.code })) ?? [];
      this.isChanged = false;
    });
    preloaderStore.preloader(false);
  };

  groupDelete = async (items: ReportTypeDtoDefId[]) => {
    preloaderStore.preloader(true, 'удаление...');
    const deleteCode = items.map((report) => report.code);
    await this.api.reportTypes.deleteReportType(deleteCode);
    await this.fetch();
    preloaderStore.preloader(false);
  };
}

export const reportTypesStore = new ReportTypesStore({ api: cmApi });
